import { Wrapper, Load } from "./Playlist.styled";
import Tile from "../Tile";
import SubHeader from "../SubHeader";
import useWindowDimensions from "../../utils/useWindowDimensions";

function Playlist({ playlist, onGameClick, onMoreClick }) {
  const { width } = useWindowDimensions();

  return (
    <>
      <SubHeader
        showMore={width && width < 800 ? false : playlist.showMore}
        title={playlist.name}
        onMoreClick={onMoreClick}
      >
        {playlist.name}
      </SubHeader>
      <Wrapper>
        <Load>
          {playlist.games.map((game, index) => {
            return (
              <Tile
                onGameClick={onGameClick}
                key={game._id}
                game={game}
                gameIndex={index}
              />
            );
          })}
        </Load>
      </Wrapper>
    </>
  );
}

export default Playlist;
